import React, { useEffect, useState } from 'react';
import {AtProgress} from 'taro-ui';
import {LabelWidget} from "../../index";

const TProgressWidget = (props:any) => {
  const {
    value,
    label,
    labelPosition,
    labelAlignment,
    labelWidth,
    color,
    fontSize,
    fontStyle,
    progresscolor,
    progressBackgroundColor,
    isHidePercent,
    progressHeight} = props;

  return (
    <LabelWidget
      label={label}
      labelAlignment={labelAlignment}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      fontSize={fontSize}
      color={color}
      fontStyle={fontStyle}
      progressBackgroundColor={progressBackgroundColor}
      progressHeight={progressHeight}
      
    >
      <AtProgress color={progresscolor} isHidePercent={!isHidePercent} percent={value}/>
    </LabelWidget>

  );
};

export default TProgressWidget;
